import { Component, OnInit, Type, ViewChild, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UniversalDetail } from '../../models/universal.model';
import { LoaderService } from '../../service/loader.service';
import { Message } from '../../service/message.service';
import { RestService } from '../../service/rest.service';
import { TranslocoService } from '@jsverse/transloco';
@Component({
  selector: 'app-universal-create',
  templateUrl: './universal-create.component.html',
  styles: [],
  standalone: false,
})
export class UniversalCreateComponent implements OnInit {
  constructor(
    private router: ActivatedRoute,
    private route : Router,
    private loader: LoaderService,
    private message: Message,
    private rest: RestService,
    private viewContainerRef: ViewContainerRef,
        private translocoService:TranslocoService
  ) {}
  @ViewChild('customCardUniversalDetailsContainer', { read: ViewContainerRef, static: true })
  customCardUniversalDetailsContainerRef!: ViewContainerRef;
    @ViewChild('customTabsUniversalDetailsContainer', { read: ViewContainerRef, static: true })
  customTabsUniversalDetailsContainerRef!: ViewContainerRef;
  myData: any = {};
  idElement: string = '';
  originalData: any = {};
  dataParams: UniversalDetail = {
    currentBreadcrumb: 0,
    endpoint: '',
    breadcrumb: [],
    details: [],
    environment: {},
    api: {},
    stepMinutes: 5,
    showClock: false,
    use24h: false,
  };
  tablesData: any = {};
  showModelDelete: boolean = false;
  currentTab: any = {};
  subElementModalValue: any = {};
  showModalSubElement = false;
  isNewSubElement = false;
  listOfDataForSelects: any = {};
  listOfDataForSubSelects: any = {};
  myCustomFormData: any = new FormData();
  baseUrl: string = '';
  endPointBackend: string = '';
  specialModalTimeToShow: any;
  tempVariable: any;
  elementId : string = 'id'
    static myTranslations:any = {}
  ngOnInit(): void {
    this.getTranslationLabels()
    if (this.dataParams.elementId) {
      this.elementId = this.dataParams.elementId
    }
    this.router.data.subscribe((data: any) => {
      this.dataParams = data;
      this.baseUrl = this.dataParams.api.baseUrl;
      this.endPointBackend = this.dataParams.api.baseUrl;
      this.myData.source = 'MANUAL'
    });
  }

  generateCustomAction(component: Type<any>, item?: any) {
    setTimeout(() => {
      const componentRef = this.viewContainerRef.createComponent(component);
      componentRef.instance.fatherElement = item;
      componentRef.instance.fatherContaierRef = this;
    }, 0);
  }

  checkCustomParts() {
    if (this.dataParams.customCard) {
      this.customCardUniversalDetailsContainerRef.clear();
      const componentCardRef = this.customCardUniversalDetailsContainerRef.createComponent(this.dataParams.customCard);
      componentCardRef.instance.fatherContaierRef = this;
    }
        if (this.dataParams.customTabs) {
      this.customTabsUniversalDetailsContainerRef.clear();
      const componentTabsRef = this.customTabsUniversalDetailsContainerRef.createComponent(this.dataParams.customTabs);
      componentTabsRef.instance.fatherContaierRef = this;
    }
  }

  getDataForSubSelect(endpoint: string, property: string) {
    this.loader.on();
    this.rest.get(`${endpoint}`).subscribe({
      next: (response: any) => {
        this.listOfDataForSubSelects[property] = response;
        this.loader.off(true);
      },
      error: () => {
        this.loader.off(true);
      },
    });
  }

  manageFiles(event: any, dataForm: any) {
    const file = event.target.files[0];
    this.myCustomFormData.append(dataForm.element, file);
  }

  getDataForSelect(endpoint: string, property: string) {
    this.loader.on();
    this.rest.get(`${endpoint}`).subscribe({
      next: (response: any) => {
        this.listOfDataForSelects[property] = response.data;
        this.loader.off(true);
      },
      error: () => {
        this.loader.off(true);
      },
    });
  }


  getSubTables() {
    if (this.dataParams.tables) {
      for (let index = 0; index < this.dataParams.tables.length; index++) {
        this.loader.on();
        const table = this.dataParams.tables[index];
        if (this.dataParams.environment.testing) {
          this.tablesData[table.name] = this.dataParams.mockData;
        }
        this.rest
          .get(
            `${this.dataParams.endpoint}/${this.idElement}/${table.endpoint}`
          )
          .subscribe({
            next: (value: any) => {
              this.loader.off(true);
              if (value.length > 0) {
                this.tablesData[table.name] = value;
              } else {
                this.tablesData[table.name] = value.data;
                this.tablesData[table.name + 'Pagination'] = {
                  currentPage:value.currentPage,
                  totalPages:value.totalPages,
                };
              }
            },

            error: (error: any) => {
              this.message.showMessage(JSON.stringify(error.message), 'error');
              this.loader.off(true);
            },
          });
      }
    }
  }

  createElement(t: any) {
    let currentItem = JSON.parse(JSON.stringify(this.myData));
    if (this.dataParams?.elementToRemove) {
      this.dataParams.elementToRemove.forEach((element: string) => {
        delete currentItem[element];
      });
    }

    for (const [key, value] of Object.entries(currentItem)) {
      this.myCustomFormData.append(key, value);
    }

    if (this.dataParams.environment.testing) {
      this.originalData = JSON.parse(JSON.stringify(this.myData));
      this.message.showMessage(t('editedElement'), 'success');
    } else {
      this.loader.on();
 let myFunction = this.rest
        .post(
          `${this.dataParams.endpoint}`,
          ( this.dataParams.useFormData ? this.myCustomFormData : currentItem )
        )
      myFunction
        .subscribe({
          next: (value:any) => {
            this.myCustomFormData = new FormData();
            this.originalData = JSON.parse(JSON.stringify(this.myData));
            this.loader.off(true);
            this.message.showMessage(t('elementCreated'), 'success');
            this.route.navigate([(`${this.t(this.dataParams.route)}/`).replace(':id',value[this.elementId])])
          },

          error: (error: any) => {
            this.myCustomFormData = new FormData();
            this.message.showMessage(JSON.stringify(error.message), 'error');
            this.loader.off(true);
          },
        });
    }
  }

  getTranslationLabels() {
    this.translocoService.selectTranslation(this.translocoService.getActiveLang()).subscribe((res) => {
      UniversalCreateComponent.myTranslations = res
    })
  }

    t(label: any) {
    return UniversalCreateComponent.myTranslations && label ? UniversalCreateComponent.myTranslations[label] : label
  }

  showEditSubElement(item: any, tab: any) {
    this.subElementModalValue = item;
    this.currentTab = tab;
    this.isNewSubElement = false;
    this.showModalSubElement = true;
  }

  addSubElement(tab: any) {
    this.subElementModalValue = {};
    this.isNewSubElement = true;
    this.currentTab = tab;
    this.showModalSubElement = true;
  }

  confirmSubElement() {
    this.showModalSubElement = false;
    this.loader.on();

    let currentItem = JSON.parse(JSON.stringify(this.subElementModalValue));

    if (this.currentTab?.elementToRemove) {
      this.currentTab?.elementToRemove.forEach((element: string) => {
        delete currentItem[element];
      });
    }
    for (const [key, value] of Object.entries(currentItem)) {
      this.myCustomFormData.append(key, value);
    }

    let functionOfModal = this.isNewSubElement
      ? this.rest.post(
          `${this.dataParams.endpoint}/${this.idElement}/${this.currentTab.endpoint}`,
          this.currentTab.useFormData ? this.myCustomFormData : currentItem
        )
      : (this.dataParams.requirePut ? this.rest.put(
          `${this.dataParams.endpoint}/${this.idElement}/${this.currentTab.endpoint}/${this.subElementModalValue[this.elementId]}`,
          this.currentTab.useFormData ? this.myCustomFormData : currentItem
        ): this.rest.patch(
          `${this.dataParams.endpoint}/${this.idElement}/${this.currentTab.endpoint}/${this.subElementModalValue[this.elementId]}`,
          this.currentTab.useFormData ? this.myCustomFormData : currentItem
        ));
    if (this.currentTab.single) {
      functionOfModal = this.dataParams.requirePut ? this.rest.put(
        `${this.dataParams.endpoint}/${this.idElement}/${this.currentTab.endpoint}`,
        this.currentTab.useFormData ? this.myCustomFormData : currentItem
      ) : this.rest.patch(
        `${this.dataParams.endpoint}/${this.idElement}/${this.currentTab.endpoint}`,
        this.currentTab.useFormData ? this.myCustomFormData : currentItem
      );
    }
    functionOfModal.subscribe({
      next: () => {
        this.myCustomFormData = new FormData();
        this.rest
          .get(
            `${this.dataParams.endpoint}/${this.idElement}/${this.currentTab.endpoint}`
          )
          .subscribe({
            next: (value: any) => {
              this.myCustomFormData = new FormData();
              this.loader.off(true);
              if (value.length > 0) {
                this.tablesData[this.currentTab.name] = value;
              } else {
                this.tablesData[this.currentTab.name] = value.data;
                this.tablesData[this.currentTab.name + 'Pagination'] = {
                  currentPage:value.currentPage,
                  totalPages:value.totalPages,
                };
              }
            },

            error: (error: any) => {
              this.message.showMessage(JSON.stringify(error.message), 'error');
              this.loader.off(true);
            },
          });
      },

      error: (error: any) => {
        this.myCustomFormData = new FormData();
        this.message.showMessage(JSON.stringify(error.message), 'error');
        this.loader.off(true);
      },
    });
  }

  showDeleteSubElement(item: any, tab: any) {
    this.subElementModalValue = item;
    this.currentTab = tab;
    this.showModelDelete = true;
  }

  manageChangeValueSubSelect(value: any, event: any) {
    this.subElementModalValue[value.element] =
      event[value.bindValueSelect ?? 'value'];
  }

  manageChangeValueSubSelectSingle(value: any, event: any, name: string) {
    this.tablesData[name][value.element] =
      event[value.bindValueSelect ?? 'value'];
  }

  getCurrentValueForSubSelect(data: any, value: any) {
    if (data?.selectArray?.length > 0) {
      let valueForSubSelect = data.selectArray.find(
        (mySubValue: any) => mySubValue.value == value
      );
      return valueForSubSelect;
    } else {
      let valueForSubSelect = this.listOfDataForSubSelects[data.element].find(
        (mySubValue: any) => mySubValue[this.elementId] == value
      );
      return valueForSubSelect;
    }
  }

  deleteSubElement() {
    this.showModelDelete = false;
    this.loader.on();
    this.rest
      .delete(
        `${this.dataParams.endpoint}/${this.idElement}/${this.currentTab.endpoint}/${this.subElementModalValue[this.elementId]}`
      )
      .subscribe({
        next: () => {
          this.rest
            .get(
              `${this.dataParams.endpoint}/${this.idElement}/${this.currentTab.endpoint}`
            )
            .subscribe({
              next: (value: any) => {
                this.loader.off(true);
                if (value.length > 0) {
                this.tablesData[this.currentTab.name] = value;
              } else {
                this.tablesData[this.currentTab.name] = value.data;
                this.tablesData[this.currentTab.name + 'Pagination'] = {
                  currentPage:value.currentPage,
                  totalPages:value.totalPages,
                };
              }
              },

              error: (error: any) => {
                this.message.showMessage(
                  JSON.stringify(error.message),
                  'error'
                );
                this.loader.off(true);
              },
            });
        },

        error: (error: any) => {
          this.message.showMessage(JSON.stringify(error.message), 'error');
          this.loader.off(true);
        },
      });
  }

  subTableChangePage(tab: any, page: number) {
    this.loader.on()
    this.rest
      .get(
        `${this.dataParams.endpoint}/${this.idElement}/${tab.endpoint}?options={%22page%22:${page},%22filters%22:[]}`
      )
      .subscribe({
        next: (value: any) => {
          this.loader.off(true);
          if (value.length > 0) {
            this.tablesData[tab.name] = value;
          } else {
            this.tablesData[tab.name] = value.data;
            this.tablesData[tab.name + 'Pagination'] = {
              currentPage: value.currentPage,
              totalPages: value.totalPages,
            };
          }
        },

        error: (error: any) => {
          this.message.showMessage(
            JSON.stringify(error.message),
            'error'
          );
          this.loader.off(true);
        },
      });
  }

  resetToOriginal() {
    this.myData = JSON.parse(JSON.stringify(this.originalData));
  }
}
